import React from 'react'
import { LinkOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import PropTypes from 'prop-types'

const LinkButton = ({ link, shape }) => (
  <a href={link} rel="noreferrer" target="_blank">
    <Button aria-label="link" icon={<LinkOutlined />} shape={shape} />
  </a>
)

LinkButton.propTypes = {
  link: PropTypes.string.isRequired,
  shape: PropTypes.string,
}

LinkButton.defaultProps = {
  shape: 'circle',
}

export default LinkButton
